import Cookies from "js-cookie";

export function checkCookieDisclaimer(
  cname: string,
  isLoggedIn: string | null
): boolean {
  const isAccepted = Cookies.get(cname);

  if (isAccepted || isLoggedIn) {
    return true;
  } else {
    return false;
  }
}

export function setCookieDisclaimer(
  cname: string,
  cvalue: string,
  exdays: number
) {
  const expires = new Date();
  expires.setTime(expires.getTime() + exdays * 24 * 60 * 60 * 1000);
  Cookies.set(cname, cvalue, { expires: expires, path: ";path=/" });
}

export function acceptCookieDisclaimer() {
  setCookieDisclaimer("read_cookies_disclaimer", "true", 365);
  checkCookieDisclaimer("read_cookies_disclaimer", null);
}
